import {
  Box,
  Image,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaTimes, FaHandshake } from "react-icons/fa";
import { BsCheckCircle } from "react-icons/bs";
import { photoBaseURL } from "../../../service/api";
import { getUserProfile } from "../../../context/getUserProfile";
import { useEffect, useState } from "react";

import ShareToSocial from "./ShareToSocial";
import { useNavigate } from "react-router-dom";
import thelogo from "../../../assets/thelogo.png";
import { trunc } from "../../../utils";

function AboutUser({
  selectedUser,
  setSelectedUser,
  user,
  handleFollow,
  handleNotInterested,
  anyRandomUser,
}) {
  const modeBg = useColorModeValue("#fff", "#030c1b");
  const modeBoxShadow = useColorModeValue("#80808024", "#030c1b");
  const [following, setFollowing] = useState(false);

  const circleStyle = {
    bg: "#fff",
    w: "40px",
    h: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const navigate = useNavigate();
  const handleUnInterested = async (selectedUser) => {
    await handleNotInterested(selectedUser);
    setSelectedUser(anyRandomUser);
  };
  const handleTheFollow = async (selectedUser) => {
    await handleFollow(selectedUser?.id, following)
    setSelectedUser(anyRandomUser)
  }
  
  return (
    <Stack
      alignItems={"flex-start"}
      borderRadius="15px"
      boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
      p="15px 20px"
      bg={modeBg}
      mb="20px"
      flex="7"
      h="100% !important"
    >
      <Stack
        direction={["column", "row"]}
        alignItems={"flex-start"}
        spacing="20px"
        w="100%"
        justifyContent={"space-between !important"}
      >
        {selectedUser && (
          <Box
            position={"relative"}
            display="flex"
            justifyContent={"center"}
            alignItems="center"
            flex={"1"}
          >
            <Image
              borderRadius={"15px"}
              w="400px"
              h="300px"
              objectFit={"cover"}
              src={selectedUser?.picture}
              alt="random user pic"
              fallbackSrc={thelogo}
              boxShadow={"1px 8px 12px 3px #80808026"}
            />
            <Stack
              direction={"row"}
              alignItems="center"
              position={"absolute"}
              bottom="-15px"
              spacing={"10px"}
            >
              <Tooltip label="Not interested">
                <Box
                  {...circleStyle}
                  cursor="pointer"
                  onClick={() => handleUnInterested(selectedUser)}
                >
                  <FaTimes color="#170731" fontSize={"1.2em"} />
                </Box>
              </Tooltip>
              <Tooltip label={following ? "Unfollow" : "Follow"}>
                <Box
                  {...circleStyle}
                  cursor="pointer"
                  onClick={() => handleTheFollow(selectedUser, following)}
                >
                  <FaHandshake color="#00B90D" fontSize={"2em"} />
                </Box>
              </Tooltip>
              <ShareToSocial
                id={selectedUser?.id}
                username={selectedUser?.username}
              />
            </Stack>
          </Box>
        )}

        {selectedUser && (
          <Stack
            flex="1"
            justifyContent={"center"}
            alignItems="center"
            spacing={"20px"}
            w={["100%", "unset"]}
          >
            <Text
              fontWeight={"bold"}
              fontSize="1.7em"
              mt="10px"
              alignSelf="center"
            >
              About
            </Text>
            <Stack direction={"row"} alignItems="center" spacing={"30px"}>
              <Text
                color="#666666"
                fontSize="1.2em"
                fontWeight={"bold"}
                cursor="pointer"
                onClick={() => {
                  navigate(`/view-profile/${selectedUser?.id}`);
                }}
              >
                {`${selectedUser?.username}`}
              </Text>
              {parseInt(selectedUser?.verification?.status) && (
                <BsCheckCircle color="#00B90D" fontSize={"1.2em"} />
              )}
            </Stack>

            <Stack
              direction={"row"}
              alignItems="center"
              spacing={"10px"}
              justifyContent="space-between"
            >
              {selectedUser?.interest?.map((interest, key) => {
                return (
                  <Text
                    key={key}
                    color="#080808"
                    fontWeight={"bold"}
                    bg="#F3F3F3"
                    borderRadius={"15px"}
                    p="5px 10px"
                    fontSize={".9em"}
                    textTransform="capitalize"
                  >
                    {interest}
                  </Text>
                );
              })}
            </Stack>
            <Text color="#949494" fontSize={".8em"} maxW="350px">
              {/* {selectedUser?.about} */}
              {selectedUser?(<>     {trunc(`${selectedUser?.about}`, 700)} {selectedUser?.about?.length > 700 && 
              <span style={{cursor:"pointer"}} onClick={() => {navigate(`/view-profile/${selectedUser?.id}`)}}>Read more</span>}</>) : ' '}
         
            </Text>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}

export default AboutUser;
